import { useI18n } from 'hooks/useI18n';
import { UIOfferWhenSection } from 'interfaces/ui/ui-offer-when-section';
import { UIOfferWhenWatchFaq } from 'interfaces/ui/ui-offer-when-watch-faq';
import Image from 'next/image';
import { getPublicPath } from 'utils/paths';
import JobOfferLongText from '../JobOfferLongText';
import JobOfferSubsection from '../JobOfferSubsection';
import {
  StyledWhenWatch,
  StyledWhenWatchFaqs,
  StyledWhenWatchIcon
} from './WhenWatch.styled';
import WhenWatchFaqs from './WhenWatchFaqs';

const WhenWatch = ({
  watchIntro,
  watchFaqs,
  migratedToMarkdown
}: UIOfferWhenSection) => {
  const { t } = useI18n('job-offer');

  return (
    <StyledWhenWatch>
      <StyledWhenWatchIcon>
        <Image
          src={getPublicPath('/images/icons/watch-duty.svg')}
          width={64}
          height={64}
        />
      </StyledWhenWatchIcon>
      <JobOfferSubsection title={t('when.watches')}>
        {watchIntro && (
          <JobOfferLongText isMarkdown={migratedToMarkdown}>
            {watchIntro}
          </JobOfferLongText>
        )}

        {watchFaqs && watchFaqs.length > 0 && (
          <StyledWhenWatchFaqs>
            {watchFaqs.map((f: UIOfferWhenWatchFaq, i: number) => (
              <WhenWatchFaqs
                key={i}
                watchFaqs={f}
                migratedToMarkdown={migratedToMarkdown}
              />
            ))}
          </StyledWhenWatchFaqs>
        )}
      </JobOfferSubsection>
    </StyledWhenWatch>
  );
};

export default WhenWatch;
